export function uniquePlants(typeVersions) {
  const plants = Object.values(typeVersions).flat();
  const plantsHashMap = plants.reduce((hashMap, plant) => ({ ...hashMap, [plant.wkzNumber]: plant }), {});
  const unique = Object.keys(plantsHashMap).map((wkzNumber) => plantsHashMap[wkzNumber]);
  unique.sort((a, b) => (a.plantName.toLowerCase() < b.plantName.toLowerCase() ? -1 : 1));

  return unique;
}

export function separatePlantCodeAndName(plantsByBodyTypes) {
  const entries = Object.entries(plantsByBodyTypes);
  const plantEntries = entries.map(([bodyType, plants]) => [bodyType, Object.entries(plants)]);
  const plantCodeNames = plantEntries.map(([bodyType, plants]) => {
    const plantsMap = plants.map(([plantCode, plantName]) => ({ plantCode, plantName }));

    return [bodyType, plantsMap];
  });

  const mappedPlants = plantCodeNames.reduce((prev, [bodyType, plantsMap]) => ({ ...prev, [bodyType]: plantsMap }), {});

  return mappedPlants;
}
